export default "__VITE_ASSET__oJP66cqF__"